export default "__VITE_ASSET__B1t6qkO4__"